import React, { useContext } from 'react';

//components
// import FloatingAddClusterButton from "./FloatingAddClusterButton";
import ClustersListTableContent from './ClustersListTableContent';
import ClustersListPageHeader from './ClustersListPageHeader';

//global state
import { StateContext } from '../../AppStateContext';

// Fade in
import FadeIn from 'react-fade-in';

//styling
import './Styles.scss';
import './clusterRow.css';

const ClustersListContent = ({ clusters, setClusters }) => {
  //consume global state
  const state = useContext(StateContext);

  return (
    <FadeIn transitionDuration={1000}>
      <div
        className={
          state.theme === 'dark'
            ? '__clustersListPage __clustersListPageDark'
            : '__clustersListPage __clustersListPageLight'
        }
        style={{ zoom: '100%' }}
      >
        <ClustersListPageHeader />

        <div
          className={
            state.theme === 'dark'
              ? '__clustersTable __clustersTableDark'
              : '__clustersTable __clustersTableLight'
          }
        >
          <ClustersListTableContent
            clusters={clusters}
            setClusters={setClusters}
          />
        </div>

        {/* <FloatingAddClusterButton /> */}
      </div>
    </FadeIn>
  );
};

export default ClustersListContent;
